export default {
  recentActivities: 'Recent Activities',
  text: 'Text',
  fax: 'Fax',
  voicemail: 'Voicemail',
  call: 'Call',
} as const;
